import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { GroupRulesSummary } from './groupRulesSummary.component';
import { selectCurrentExperience } from '../../../../../modules/experience';
import { selectIsGroupExperience } from '../../../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
  isGroupExperience: selectIsGroupExperience,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(GroupRulesSummary);
